import axios from 'common/utils/axios';

const organizationPrivacyPolicyApi = axios('organization-privacy-policy');

export const getOrganizationPrivacyPolicyApi = () => {
  return organizationPrivacyPolicyApi.get('');
};
